<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
            tbody-tr-class="rowClass"
        >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma dívida encontrada.</p>
            </template>
            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
            </template>
            <template slot="selecionar" slot-scope="row">
                <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item)" @change="toggleCheck($event, row.item)" />
            </template>
            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.numeroDivida)" class="m-0 p-0">
                    <span class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}"> {{ row.item.numeroDivida }} </span>
                </b-link>
                <b-link @click="downloadArquivo(row.item.codCdaSefa, row.item.numeroDivida)" class="m-0 p-0">
                    <span class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}"> (PDF) </span>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}"> {{ row.item.contribuinte }} </p>
                <template v-for="c in row.item.outrosContribuintes">
                    <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}" :key="c.codDevedor">{{ c.contribuinte }}</p>
                </template>
            </template>
            <template slot="3" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}"> {{ row.item.cpfCnpj | cpfCnpj }}</p>
                <template v-for="c in row.item.outrosContribuintes">
                    <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}" :key="c.codDevedor">{{ c.cpfCnpj | cpfCnpj }}</p>
                </template>
            </template>
            <template slot="4" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{ row.item.tipoCredito }}</p>
            </template>
            <template slot="5" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{ row.item.origem }} <i v-if="row.item.prescricao" class="fa fa-warning texto-amarelo" /></p>
            </template>
            <template slot="6" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{ row.item.dtInscricao }}</p>
            </template>
            <template slot="7" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{ row.item.comarca }}</p>
            </template>
            <template slot="8" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{ row.item.valor | currency }}</p>
            </template>
            <template slot="9" slot-scope="row">
                <p class="m-0 p-0" :class="{'texto-vermelho': row.item.cadicmsVencido, 'texto-amarelo' : row.item.prescricao}">{{row.item.excecaoInativa}}</p>
            </template>

        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import axios from 'axios'
import ExtratoCda from "../../shared/components/ExtratoCda";

export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarDividas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        rowClass(item) {
            if(!item) return
            if (item.obrigatoriedadeEnvio) return 'table-dark'
        },
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)
            } else {
                item.checked = checked
                const index = this.selecteds.indexOf(item)
                this.selecteds.splice(index, 1)
                this.configTable.checkedAll = false
            }

        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'contribuinte'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cpfCnpj'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'origem'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'dataInscricao'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'comarca'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'valorTotal'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        async downloadArquivo(codCdaSefa, numeroDivida) {
            await axios.get(`${process.env.VUE_APP_ROOT_API}/v1/cdaDisponivelAjuizamento/baixarPdfAssinado/${codCdaSefa}`, {
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    window.scrollTo(0,0);
                    return;
                }

                let blob = new Blob([response.data], {type: 'application/pdf'});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'certidao_' + numeroDivida + '.pdf';
                link.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        },
        abrirModalExtratoCda(numeroCda) {
            this.$refs['extratoCda'].abrirExtrato(numeroCda);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

.texto-amarelo {
    color: #FFC107 !important;
    font-weight: bold !important;
}

.texto-vermelho {
    color: red;
    font-weight: bold !important;
}

</style>
